export enum BizTypeEnum {
  Paper = 'paper',
  CourseOutlineTask = 'course_outline_task',
  Quiz = 'quiz',
}
